const hideDropdown = (listElement, btn) => {
  // eslint-disable-next-line no-param-reassign
  listElement.style.display = 'none';
  listElement.classList.remove('active');
  btn.classList.remove('active');
};

export const extendableButton = (btn, listElement) => {
  if (!btn) {
    return;
  }

  btn.addEventListener('click', (event) => {
    event.stopPropagation();
    if (btn.classList.contains('active')) {
      hideDropdown(listElement, btn);
      return;
    }

    // eslint-disable-next-line no-param-reassign
    listElement.style.display = 'block';
    listElement.classList.add('active');
    btn.classList.add('active');
  });

  window.addEventListener('click', () => {
    if (btn.classList.contains('active')) {
      hideDropdown(listElement, btn);
    }
  });
};
